<div [ngClass]="{ card: mode === 'card' }">
  <div
    style="display: flex; justify-content: space-between"
    [ngClass]="{
      'modal-header': mode === 'dialog',
      'card-header': mode === 'card'
    }"
  >
    <h4 [ngClass]="{ 'modal-title': mode === 'dialog' }">
      {{ "admin.locations.voucher.title" | translate }}
      <span style="color: #2d2e4080; font-size: 14px; margin-left: 4px">
        {{ count }} {{ "admin.locations.voucher.code" | translate }}s
      </span>
    </h4>
    <app-export
      [buttonName]="'export'"
      [data]="voucherCSVData"
      [title]="'Vouchers'"
      [ngStyle]="mode === 'dialog' ? { 'margin-right': '30px' } : {}"
    ></app-export>
    <button
      *ngIf="mode === 'dialog'"
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closeModal()"
    ></button>
  </div>
  <div class="container-fluid">
    <div [ngClass]="{ 'm-20': mode === 'dialog' }">
      <div class="card-header p-b-10">
        <div class="d-flex justify-content-end" style="align-items: baseline">
          <div style="flex-grow: 1">
            Total coupons actifs : {{ activeCount }}
          </div>
          <div class="media-body">
            <div class="d-inline-flex">
              <app-date-range-picker
                [form]="formFilter | asFormGroup"
                inputFormControlName="date"
              ></app-date-range-picker>
              <div class="m-r-10">
                <app-search-field
                  [form]="formFilter | asFormGroup"
                  [filterOptions]="VoucherFilter"
                  [placeholder]="'placeholder.voucherCode' | translate"
                  inputFormControlName="code"
                  (emitSelectedOptions)="saveOptionFilter($event)"
                ></app-search-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive data-table">
          <form>
            <table
              id="vouchers.location_partner.table"
              class="table table-striped table-border-vertical"
            >
              <thead>
                <tr>
                  <ng-container *ngFor="let column of columns">
                    <th>
                      {{ column.label | translate }}
                    </th>
                  </ng-container>
                </tr>
              </thead>
              <tbody *ngIf="!(loading$ | async)">
                <ng-container
                  *ngFor="let voucher of voucherList; let i = index"
                >
                  <tr>
                    <ng-template #none>
                      <td>
                        {{ "undefined" | translate }}
                      </td>
                    </ng-template>
                    <td *ngIf="voucher.code != null; else none">
                      {{ voucher.code }}
                    </td>
                    <td *ngIf="voucher.creationDate; else none">
                      {{ voucher.creationDate | localizedDate : "short" }}
                    </td>
                    <td *ngIf="voucher.expirationDate; else none">
                      {{ voucher.expirationDate | localizedDate : "short" }}
                    </td>
                    <td *ngIf="voucher.maxUsers; else none">
                      {{ voucher.maxUsers }}
                    </td>
                    <td>
                      {{ voucher.consumerNumber }}
                    </td>
                    <td>
                      <ng-container
                        *ngFor="let status of getVoucherStatus(voucher)"
                      >
                        <span
                          [ngClass]="
                            'badge ' +
                            badgeService.getBadgeForVouchersStatus(status)
                          "
                          style="margin-right: 4px"
                        >
                          {{ "enumMapping.voucher." + status | translate }}
                        </span>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
              {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
            </div>
            <div
              *ngIf="count == 0 && !(loading$ | async) && !forbidden"
              class="d-flex justify-content-center m-t-20"
            >
              {{ "noData" | translate }}
            </div>
            <div *ngIf="(loading$ | async) && !forbidden">
              <ng-container style="float: right" class="flex">
                <div class="loader-box">
                  <div class="loader-34"></div>
                </div>
                <h6
                  class="col align-self-center f-w-600"
                  style="text-align: center"
                >
                  {{ "fetching" | translate }}
                </h6>
              </ng-container>
            </div>
          </form>
        </div>
        <div class="table-responsive data-table">
          <app-pager
            [count]="count"
            [pageSize]="pageSize"
            [pageNumber]="pageNumber"
            (emitChangePage)="changePage($event)"
            (emitChangePageSize)="itemsPerPageChange($event)"
          ></app-pager>
        </div>
      </div>
    </div>
  </div>
</div>
